import React from "react";
import { TextField } from "formik-material-ui";
import { makeStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import { Formik, Form, Field, FormikProps } from "formik";
import * as Yup from "yup";
import { useSnackbar } from "notistack";
import {colorSecondary} from "../../../Constants/theme";


const useStyles = makeStyles({
    submitButton: {
        background: colorSecondary,
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        borderRadius: "74px",
    }
});

const CollectEmail = (props) => {
    const validationSchema = Yup.object().shape({
        emailAddress: Yup.string()
            .email("Invalid email")
            .required("Required")
    });
    const { enqueueSnackbar } = useSnackbar();
    const classes = useStyles();


    return (
        <Formik
            initialValues={{
                emailAddress: "",
            }}
            onSubmit={async (values, {setStatus}) => {
                try {
                    props.setLocalEmail(values.emailAddress);
                    // console.log(values.emailAddress);
                    setStatus({success: true});
                } catch (error) {
                    enqueueSnackbar(error.message, {
                        variant: "error"
                    });
                    setStatus({success: false});
                }
            }}
            validationSchema={validationSchema}
        >
            {
                (props: FormikProps<{emailAddress: string}>) => {
                    return (
                        <Form>
                            <Box
                                display="flex"
                                flexDirection="column"
                                flexWrap="wrap"
                                width="100%"
                                marginBottom="16px"
                                marginTop="26px"
                            >
                                <h3>We have the answer ready for you, but we'd love your email first.</h3> 
                                <Field
                                    component={TextField}
                                    name="emailAddress"
                                    label="Email Address"
                                    variant="standard"
                                    color="secondary"
                                    type="email"
                                    margin="normal"
                                    onChange={props.handleChange}
                                    value={props.values.emailAddress}
                                />
                                {/* TODO: ПОСМОТРИ СЮДА!!!! https://stackworx.github.io/formik-material-ui/docs/guide/faq */}
                            </Box>
                            <Button
                                variant="contained"
                                type="submit"
                                data-testid="submitButton"
                                className={classes.submitButton}
                                fullWidth
                            >
              Submit
                            </Button>
                        </Form>
                    );}
            }
        </Formik>
    );
};

 
export default CollectEmail;
